<template>

    <div id="app">
        <!-- NAV -->
        <div class="container">
            <nav class="navbar" role="navigation" aria-label="main navigation">
                <div class="navbar-brand">
                    <a class="navbar-item" href="#">
                        <img :src="'/img/logo.png'" width="50" alt="logo">
                    </a>

                    <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false"
                        data-target="navbarBasicExample" @click="toggleMenu('test')">
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </a>
                </div>

                <div id="navbarBasicExample" class="navbar-menu"  v-bind:class="{ 'is-active': isActive }">
                    <div class="navbar-start">
       
                    </div>

                    <div class="navbar-end">
                        <div class="navbar-item">
                            <div class="buttons">
                                <!--<router-link to="/" class="navbar-item">Home</router-link>/-->
                                
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
        <!--/ END NAV-->
        <router-view />
    </div>
</template>
<script>
   
    export default {
        data: function () {
            return {
                isActive: false
            }
        },
        methods:{
            toggleMenu(e) {
                this.isActive = !this.isActive;
            }
        },
       
    };
</script>
<style>
  body{
      font-family: 'Comfortaa', cursive !important;
  }
</style>
